import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IllustrationEnvelope = function IllustrationEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 140 140"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "M111.366 51.699 88.924 82.576c-12.663-6.072-21.845.816-24.26 2.941L29.725 53.685 75.338 8.736z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-envelope_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.204 75.752 11.46 10.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "m53.204 75.752 11.46 10.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "m52.53 76.492 11.46 10.44 1.347-1.479-11.46-10.44zm12.807 8.961-11.46-10.44-1.347 1.479 11.46 10.44z",
    mask: "url(#illustration-envelope_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "m109.977 50.024 1.39 1.673L96.757 71.8v-4.823zM52.704 74.62 29.725 53.686l1.337-1.33 21.642 18.303z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-envelope_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.373 8 29 53.701l.321-.32z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M75.373 8 29 53.701l.321-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m75.373 8 .702.712-1.404-1.424zM29 53.701l-.705-.709 1.407 1.421zm.321-.32-.702-.712-.003.004zm45.35-46.093-46.373 45.7 1.404 1.425 46.373-45.7zM29.705 54.41l.322-.32-1.41-1.418-.322.32zm.318-.316L76.075 8.712 74.67 7.288 28.619 52.669z",
    mask: "url(#illustration-envelope_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "m52.867 76.122.004.004 11.168 9.977a77.249 77.249 0 0 0-4.13 4.114c-7.522 7.91-15.356 18.292-21.303 26.687a421.488 421.488 0 0 0-7.245 10.562c-.77 1.16-1.398 2.12-1.861 2.834V54.833zm43.793-2.418.002-.002L111.5 53.22v57.957c-5.607-14.832-15.169-23.458-18.033-25.798l-.005-.004a17.822 17.822 0 0 0-.873-.652l-.013-.009a26.55 26.55 0 0 0-2.745-1.682z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "M45.748 107.05a378.436 378.436 0 0 1 7.802-10.824c2.955-3.942 5.293-6.876 6.891-8.822a134.819 134.819 0 0 1 2.123-2.526l1.371 1.227L59.92 90.1l-.01.01c-4.783 5.03-9.692 11.059-14.162 16.941Zm47.719-21.671-.005-.004a8.533 8.533 0 0 0-.673-.497 1.254 1.254 0 0 0-.291-.145.616.616 0 0 0-.074-.017 26.39 26.39 0 0 0-2.596-1.579l1.291-1.784c8.342 6.184 13.428 14.31 16.436 20.945.301.664.581 1.313.842 1.943-5.522-10.611-12.546-16.914-14.93-18.862Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "m92.009 85.538.009.006.002.001.009.006.04.027.16.114c.14.102.348.257.608.464 2.931 2.395 13.151 11.625 18.513 27.576l-81.28 17.526.078-.12a360.14 360.14 0 0 1 2.045-3.118 425.12 425.12 0 0 1 7.215-10.525c5.927-8.371 13.702-18.68 21.12-26.484l.003-.003a76.07 76.07 0 0 1 4.15-4.128l.007-.006.007-.007v-.002l.005-.003.015-.015.06-.06.235-.234c1.692-1.577 10.878-9.45 23.846-2.897l.003.001a25.025 25.025 0 0 1 3.15 1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "m64.531 72.187.075.02.077-.003-.02-.5.02.5h.021l.057-.004a29.08 29.08 0 0 0 1.053-.081c.727-.07 1.784-.192 3.116-.407 2.663-.43 6.425-1.228 10.832-2.703a75.15 75.15 0 0 0 28.811-17.66l-1.403 3.488-13.855 18.234-6.902 6.346-21.608 1.048-13.423-9.041L35.463 55.42c2.3 1.596 5.258 3.61 8.459 5.691 3.6 2.34 7.51 4.768 11.133 6.778 3.613 2.004 6.978 3.615 9.476 4.298Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD7DF",
    d: "M53.204 37.935v37.818l11.46 10.44c1.713-1.599 11.137-9.588 24.417-2.983l7.176-9.801V36.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    stroke: "#DE5374",
    d: "m59.205 45.039-.049-1.13L90.9 42.551l.049 1.13zm-.001 6.498-.049-1.13 31.743-1.358.049 1.13zm.004 6.605-.05-1.13 31.744-1.358.049 1.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "M52.312 66.039V40.246h.392v26.123z"
  }));
};